export default __webpack_public_path__ + "static/media/double-chevron-up.7f9cbac8.svg";